<div class="row">
  <div class="col-md-12 pl-0">
    <div class="mb-3">
      <button mat-icon-button class="backArrow" (click)="closeEvent()">
        <mat-icon (click)="closeEvent()"> arrow_back </mat-icon>
      </button>
      <span class="capitalize ml-1" *ngIf="appState?.appCompanyAliasValue == 'valuetest'"
        >Created Date : <strong>{{ selectedInfo?._id?.date | simpleDate }}</strong>
        <button mat-button color="primary"></button>
        <button
          *ngIf="appState?.appCompanyAliasValue == 'valuetest' && (userState.userDetail$ | async)?.roles?.[0] === 'companyManager'"
          mat-flat-button
          class="ml-2"
          color="primary"
          (click)="exportToCSV()"
          [pmx-progress-button]="isExportProgress"
        >
          Export to CSV
        </button>
      </span>
      <span class="capitalize ml-1" *ngIf="appState?.appCompanyAliasValue != 'valuetest'">
        <strong> {{ DEFAULT_AUTOMATED_CAMP[selectedInfo?._id] || selectedInfo?._id }} </strong></span
      >
    </div>
    <div class="posButtonWrap text-right pl-3 float-right">
      <button mat-stroked-button color="primary" class="ml-4 addBtn create-campaign" (click)="openEditCampaignSheet()">
        <p class="mb-0">+ Add Contact</p>
      </button>
    </div>
  </div>

  <div class="row w-100 m-0">
    <div class="col-md-3 col-sm-4 col-6" *ngIf="appState?.appCompanyAliasValue == 'valuetest'">
      <mat-form-field class="w-100">
        <mat-select (selectionChange)="emailStatus($event)" [(value)]="selectedEmailStatus" placeholder="Email Status">
          <mat-option [value]="'all'">All</mat-option>
          <mat-option [value]="'read'">Read</mat-option>
          <mat-option [value]="'unRead'">Unread</mat-option>
          <mat-option [value]="'Not Sent'">Not sent</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3 col-sm-4 col-6">
      <mat-form-field class="w-100">
        <mat-label> Search </mat-label>
        <input
          matInput
          [(ngModel)]="searchValue"
          autocomplete="off"
          placeholder="Search Email"
          [ngModel]="model"
          (ngModelChange)="changed($event)"
        />
      </mat-form-field>
    </div>
  </div>

  <div
    class="row w-100 m-0"
    *ngIf="!isLoadingAgentMarketCampaignStatistics && appState?.appCompanyAliasValue != 'valuetest'"
  >
    <div class="col-md-4 mb-2">
      <strong>Campaign Name:</strong>
      <span class="ms-1">{{ DEFAULT_AUTOMATED_CAMP[selectedInfo?._id] || selectedInfo?._id }} </span>
    </div>

    <div class="col-md-4 mb-3">
      <strong>Campaign Type: </strong>
      <span class="ms-1">{{ DEFAULT_AUTOMATED_CAMP[selectedInfo?._id] || selectedInfo?._id }} </span>
    </div>

    <div class="col-md-4 mb-2">
      <strong>Campaign Launched:</strong>
      <span class="ms-1">{{ selectedInfo?.data[0]?.launchDate | simpleDate }}</span>
    </div>

    <div class="col-md-4 mb-2">
      <strong>Automated / Frequency:</strong>
      <span class="ms-1"> {{ frequency ? 'Yes / ' + (frequency | titlecase) : 'No' }} </span>
    </div>

    <div class="col-md-4 mb-2">
      <strong>Last Sent:</strong>
      <span class="ms-1">
        {{ updatedDate | simpleDate }}
      </span>
    </div>

    <div class="col-md-4 mb-2">
      <strong>Total Runs:</strong>
      <span class="ms-1">
        {{ totalRun }}
      </span>
    </div>

    <div class="col-md-4 mb-2">
      <strong
        >Total Engagement:
        <mat-icon
          [matTooltip]="'Shows the percentage of recipients who opened one or more campaign emails'"
          [matTooltipPosition]="'right'"
          matTooltipClass="line-break"
          class="help-icon"
          >help_outline</mat-icon
        >
      </strong>
      <span class="ms-1">
        {{
          selectedInfo?.data[0]?.totalReadCount
            ? (((selectedInfo?.data[0]?.totalReadCount || 0) / selectedInfo.candidateTotalCount) * 100
                | number: '1.2-2') + '%'
            : 0
        }}
      </span>
    </div>
  </div>

  <div class="mb-3 row w-100">
    <div class="col-lg-12 mt-2">
      <div class="table_base">
        <div class="table-responsive table_wrap">
          <table mat-table [dataSource]="tableDataSourceInfo" class="mat-elevation-z2 w-100">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  color="primary"
                  (change)="$event ? masterToggle($event) : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleSelect(row, $event.checked) : null"
                  [checked]="selection.isSelected(row)"
                  [disabled]="row.unSubscribeAll"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell *matCellDef="let element">{{ element.position }}</td>
            </ng-container>

            <ng-container matColumnDef="fullName">
              <th mat-header-cell *matHeaderCellDef class="cm-email">Name</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element?.recipientInfo?.fullName
                    ? element.recipientInfo.fullName
                    : element?.firstName || element?.lastName
                    ? element.firstName + ' ' + element.lastName
                    : '--'
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef class="cm-email">Email</th>
              <td mat-cell *matCellDef="let element">
                {{ element.toEmail || element?.email }}
              </td>
            </ng-container>

            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef class="cm-email">Phone</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.recipientInfo?.phone || element?.phone || '--' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="emailCount">
              <th mat-header-cell *matHeaderCellDef class="cm-email">Email Count</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.totalSendCount || 0 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="emailOpenRate">
              <th mat-header-cell *matHeaderCellDef class="cm-email">Open Rate</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element?.totalSendCount > 0
                    ? (((element?.totalReadCount ?? 0) / element.totalSendCount) * 100).toFixed(0) + '%'
                    : '0%'
                }}
              </td>
            </ng-container>

            <ng-container
              matColumnDef="mlsBoard"
              *ngIf="appState?.appCompanyAliasValue == 'valuetest' && (userState.userDetail$ | async)?.roles?.[0] === 'companyManager'"
            >
              <th mat-header-cell *matHeaderCellDef class="cm-email">MLS</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.recipientInfo?.mlsBoard || '--' }}
              </td>
            </ng-container>

            <ng-container
              matColumnDef="status"
              *ngIf="appState?.appCompanyAliasValue == 'valuetest' && (userState.userDetail$ | async)?.roles?.[0] === 'companyManager'"
            >
              <th mat-header-cell *matHeaderCellDef class="align-center">Email Status</th>
              <td
                mat-cell
                *matCellDef="let element"
                class="align-center"
                [matTooltip]="element.openStatus === 'Not Sent' ? 'Equity is negative' : null"
              >
                {{
                  element?.readCount
                    ? element.readCount > 0
                      ? 'Read'
                      : 'Unread'
                    : element?.openStatus === 'unRead'
                    ? 'Unread'
                    : element?.openStatus
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="lastopened">
              <th mat-header-cell *matHeaderCellDef class="align-center">Last Opened</th>
              <td mat-cell *matCellDef="let element" class="align-center">
                {{
                  element.readCount
                    ? element.readCount > 0
                      ? (element.updatedDate | simpleDate)
                      : '--'
                    : (element.updatedDate | simpleDate)
                }}
              </td>
            </ng-container>
            <ng-container
              matColumnDef="clickType"
              *ngIf="appState?.appCompanyAliasValue == 'valuetest' && (userState.userDetail$ | async)?.roles?.[0] === 'companyManager'"
            >
              <th mat-header-cell *matHeaderCellDef>Click Type</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.urlType === 'primary_click'
                    ? 'Primary Click'
                    : element.urlType === 'expanded_click'
                    ? 'Expanded Click'
                    : element.urlType === 'document_click'
                    ? 'Document Click'
                    : element.urlType === 'listing_click'
                    ? 'Listing Click'
                    : ''
                }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
            <tr mat-row (click)="openStatusSheet(row)" *matRowDef="let row; columns: tableColumnList"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="tableColumnList.length">
                <ng-container *ngIf="!isLoadingAgentMarketCampaignStatistics; else loadingTemplate">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="assets/images/notFound.svg" />
                      <h4>No campaigns found</h4>
                    </div>
                  </div>
                </ng-container>
              </td>
            </tr>

            <ng-template #loadingTemplate>
              <div class="flex_center w-100">
                <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                <span> Please wait while we load</span>
              </div>
            </ng-template>
          </table>
          <app-status-campaign-sheet
            [campaignType]="'automatedCampaign'"
            (loadStatistics)="getAgentMarketingCampaignInfo()"
            [selectedStatus]="statusId"
            *ngIf="campaignState.openCampaignStatusSheet$ | async"
          >
          </app-status-campaign-sheet>
        </div>
        <div class="d-flex justify-content-between align-items-center m-d-block">
          <button
            *ngIf="selectedRecordIdList.length > 0"
            mat-stroked-button
            color="primary"
            class="ml-4 addBtn create-campaign"
            (click)="openCampaignSheet()"
          >
            <p class="mb-0">Add To New Campaign</p>
          </button>
          <mat-paginator
            [length]="totalRecords"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="[10, 20]"
            (page)="pageChange($event)"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
